import { buildSubdomainOrigin, getBaseDomain } from '@/common/tenant-utils';

const ADMIN_CONSOLE_SUBDOMAIN = 'admin';
const MCP_GATEWAY_SUBDOMAIN = 'gw';

export function buildAdminConsoleDashboardUrl(tenantSlug: string) {
  return `${buildSubdomainOrigin(ADMIN_CONSOLE_SUBDOMAIN)}/${tenantSlug}/dashboard`;
}

export function buildMcpGatewayUrl(tenantSlug: string) {
  return `https://${tenantSlug}.${MCP_GATEWAY_SUBDOMAIN}.${getBaseDomain()}/mcp`;
}
